import { KeyRound } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgKey = mkIcon(KeyRound);